import { Component, computed, inject, signal } from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import { SwitchBar, SwitchBarOption, Button, Skeleton } from 'excellence-ui';
import { ResponsiveValue } from '../../../../shared/components/responsive-value/responsive-value';
import { TranslocoPipe } from '@jsverse/transloco';
import { GermanNumberPipe } from '../../../../shared/pipes/german-number-pipe';
import { ConsumptionStore, getInitialFilter } from '../../stores/consumption.store';
import { form, FormField } from '@angular/forms/signals';
import { ErrorComponent } from '../../../../shared/components/error-component/error-component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-analysis-consumption-kpi-card',
  imports: [
    NgIcon,
    SwitchBar,
    SwitchBarOption,
    ResponsiveValue,
    Button,
    TranslocoPipe,
    GermanNumberPipe,
    FormField,
    ErrorComponent,
    Skeleton,
    RouterLink,
  ],
  templateUrl: './analysis-consumption-kpi-card.html',
})
export class AnalysisConsumptionKpiCard {
  private consumptionStore = inject(ConsumptionStore);

  protected consumptionFilter = signal(getInitialFilter());
  protected consumptionForm = form(this.consumptionFilter);

  protected data = computed(() => this.consumptionStore.get(this.consumptionFilter()));

  protected onClickReload() {
    this.consumptionStore.load(this.consumptionFilter());
  }

  protected async onChangeUtilityType() {
    await new Promise((resolve) => setTimeout(resolve, 0));
    const filter = this.consumptionFilter();
    if (!this.consumptionStore.get(filter)) {
      this.consumptionStore.load(filter);
    }
  }
}
